import { GuarantorCard } from "./GuarantorCardParts";

const UserPreviewCard = ({ data }) => (
  <GuarantorCard name={`${data?.fname ?? ""} ${data?.lname ?? ""}`.trim()} />
);

export default UserPreviewCard;
